//  产品种类
export const algProduceTypeOptions = [
  {
      value: "水体类",
      label: "水体类",
      children: [
          {
              value: "水表反射率产品(WR)",
              label: "水表反射率产品(WR)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星",
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星",
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星",
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星",
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星",
                  }
              ]
          },
          {
              value: "悬浮物浓度产品(SSC)",
              label: "悬浮物浓度产品(SSC)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星",
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星",
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星",
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星",
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星",
                  }
              ]
          },
          {
              value: "水表温度产品(WST)",
              label: "水表温度产品(WST)",
              children: [
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星",
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星",
                  },
              ]
          },
          {
              value: "水体叶绿素含量产品",
              label: "水体叶绿素含量产品",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星",
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星",
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星",
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星",
                  }
              ]
          },
      ]
  },
  {
      value: "辐射类",
      label: "辐射类",
      children: [
          {
              value: "辐射亮度产品(RAD)",
              label: "辐射亮度产品(RAD)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星",
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星",
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星",
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星",
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星",
                  },
                  {
                      value: "大气环境监测卫星",
                      label: "大气环境监测卫星",
                  }
              ]
          },
          {
              value: "亮温产品(BT)",
              label: "亮温产品(BT)",
              children: [
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星",
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星",
                  },
              ]
          },
          {
              value: "干涉测量相位大气延迟校正产品",
              label: "干涉测量相位大气延迟校正产品",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）",
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）",
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）",
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星",
                  },
              ]
          },
          {
              value: "后向散射系数",
              label: "后向散射系数",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）",
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）",
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）",
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星",
                  },
              ]
          }

      ]
  },
  {
      value: "植被类",
      label: "植被类",
      children: [
          {
              value: "叶面积指数产品(LAI)",
              label: "叶面积指数产品(LAI)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星"
                  },
              ]
          },
          {
              value: "植被覆盖度产品(VC)",
              label: "植被覆盖度产品(VC)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
              ]
          },
          {
              value: "植被指数产品",
              label: "植被指数产品",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
                  {
                      value: "大气环境监测卫星",
                      label: "大气环境监测卫星"
                  },
                  {
                      value: "高精度温室气体综合探测卫星",
                      label: "高精度温室气体综合探测卫星"
                  },
              ]
          },
          {
              value: "植被物候产品",
              label: "植被物候产品",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
              ]
          },
          {
              value: "植被高度产品",
              label: "植被高度产品",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
              ]
          }
      ]
  },
  {
      value: "几何类",
      label: "几何类",
      children: [
          {
              value: "正射产品(DOM)",
              label: "正射产品(DOM)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星"
                  },
              ]
          },
          {
              value: "高程产品(DEM)",
              label: "高程产品(DEM)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星"
                  },
              ]
          }
      ]
  },
  {
      value: "大气类",
      label: "大气类",
      children: [
          {
              value: "气溶胶光学厚度产品(AOD)",
              label: "气溶胶光学厚度产品(AOD)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
                  {
                      value: "大气环境监测卫星",
                      label: "大气环境监测卫星"
                  },
                  {
                      value: "高精度温室气体综合探测卫星",
                      label: "高精度温室气体综合探测卫星"
                  },
              ]
          },
          {
              value: "大气水汽含量产品(CWV)",
              label: "大气水汽含量产品(CWV)",
              children: [
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "大气环境监测卫星",
                      label: "大气环境监测卫星"
                  },
                  {
                      value: "高精度温室气体综合探测卫星",
                      label: "高精度温室气体综合探测卫星"
                  },
              ]
          }
      ]
  },
  {
      value: "陆表类",
      label: "陆表类",
      children: [
          {
              value: "地表覆盖类型产品",
              label: "地表覆盖类型产品",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "陆地生态碳监测卫星",
                      label: "陆地生态碳监测卫星"
                  },
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星"
                  },
              ]
          },
          {
              value: "地表反射率产品(LSR)",
              label: "地表反射率产品(LSR)",
              children: [
                  {
                      value: "2.1米立体测图卫星",
                      label: "2.1米立体测图卫星"
                  },
                  {
                      value: "高分辨率多模综合成像卫星",
                      label: "高分辨率多模综合成像卫星"
                  },
              ]
          },
          {
              value: "地表土壤水分产品(SSM)",
              label: "地表土壤水分产品(SSM)",
              children: [
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星"
                  },
              ]
          },
          {
              value: "干涉测量形变产品",
              label: "干涉测量形变产品",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "5米S-SAR卫星（2颗）",
                      label: "5米S-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
                  {
                      value: "高轨20米SAR卫星",
                      label: "高轨20米SAR卫星"
                  },
              ]
          },
          {
              value: "土壤盐碱度",
              label: "土壤盐碱度",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
              ]
          },
          {
              value: "地表粗糙度",
              label: "地表粗糙度",
              children: [
                  {
                      value: "3米L-SAR卫星（2颗）",
                      label: "3米L-SAR卫星（2颗）"
                  },
                  {
                      value: "1米C-SAR（2颗）",
                      label: "1米C-SAR（2颗）"
                  },
              ]
          },
          {
              value: "地表温度产品",
              label: "地表温度产品",
              children: [
                  {
                      value: "5米光学卫星",
                      label: "5米光学卫星"
                  },
                  {
                      value: "高光谱观测卫星",
                      label: "高光谱观测卫星"
                  },
              ]
          },
      ]
  },
]

// 产品类型
export const algProduceCategoryOptions = [
  {
    value: "水体类",
    label: "水体类",
  },
  {
    value: "辐射类",
    label: "辐射类",
  },
  {
    value: "植被类",
    label: "植被类",
  },
  {
    value: "几何类",
    label: "几何类",
  },
  {
    value: "大气类",
    label: "大气类",
  },
  {
    value: "陆表类",
    label: "陆表类",
  },
]

// 产品品种
export const algProduceSpaciesOptions = {
  "水体类": [
    {
      value: "水表反射率产品",
      label: "水表反射率产品",
    },
    {
      value: "悬浮物浓度产品",
      label: "悬浮物浓度产品",
    },
    {
      value: "水表温度产品",
      label: "水表温度产品",
    },
    {
      value: "水体叶绿素含量产品",
      label: "水体叶绿素含量产品", 
    }
  ],
  "辐射类": [
    {
      value: "辐射亮度产品",
      label: "辐射亮度产品",
    },
    {
      value: "亮温产品",
      label: "亮温产品",
    },
    {
      value: "干涉测量相位大气延迟校正产品",
      label: "干涉测量相位大气延迟校正产品",
    },
    {
      value: "后向散射系数",
      label: "后向散射系数",
    }
  ],
  "植被类": [
    {
      value: "叶面积指数产品",
      label: "叶面积指数产品",
    },
    {
      value: "植被覆盖度产品",
      label: "植被覆盖度产品",
    },
    {
      value: "植被指数产品",
      label: "植被指数产品",
    },
    {
      value: "植被物候产品",
      label: "植被物候产品",
    },
    {
      value: "植被高度产品",
      label: "植被高度产品",
    }
  ],
  "几何类": [
    {
      value: "正射产品",
      label: "正射产品",
    },
    {
      value: "高程产品",
      label: "高程产品",
    }
  ],
  "大气类": [
    {
      value: "气溶胶光学厚度产品",
      label: "气溶胶光学厚度产品",
    },
    {
      value: "大气水汽含量产品",
      label: "大气水汽含量产品",
    }
  ],
  "陆表类": [
    {
      value: "地表覆盖类型产品",
      label: "地表覆盖类型产品",
    },
    {
      value: "地表反射率产品",
      label: "地表反射率产品",
    },
    {
      value: "地表土壤水分产品",
      label: "地表土壤水分产品",
    },
    {
      value: "干涉测量形变产品",
      label: "干涉测量形变产品",
    },
    {
      value: "土壤盐碱度",
      label: "土壤盐碱度",
    },
    {
      value: "地表粗糙度",
      label: "地表粗糙度",
    },
    {
      value: "地表温度产品",
      label: "地表温度产品",
    }
  ]
}

export const algProduceTypeOptionsSimple = [
  {
      value:'水体类产品',
      label:'水体类产品',
      children: [
          {
              value:'水表反射率产品',
              label:'水表反射率产品',
          },
          {
              value:'悬浮物浓度产品',
              label:'悬浮物浓度产品',
          },
          {
              value:'水表温度产品',
              label:'水表温度产品',
          },
          {
              value:'水体叶绿素含量产品',
              label:'水体叶绿素含量产品',
          },
      ]
  },
  {
      value:'辐射类产品',
      label:'辐射类产品',
      children: [
          {
              value:'辐亮度产品',
              label:'辐亮度产品',
          },
          {
              value:'亮温产品',
              label:'亮温产品',
          },
          {
              value:'干涉测量相位大气延迟校正产品',
              label:'干涉测量相位大气延迟校正产品',
          },
          {
              value:'后向散射系数',
              label:'后向散射系数',
          },
      ]
  },
  {
      value:'植被类产品',
      label:'植被类产品',
      children: [
          {
              value:'植被指数产品',
              label:'植被指数产品',
          },
          {
              value:'植被覆盖度产品',
              label:'植被覆盖度产品',
          },
          {
              value:'叶面积指数产品',
              label:'叶面积指数产品',
          },
          {
              value:'植被物候产品',
              label:'植被物候产品',
          },
          {
              value:'植被高度产品',
              label:'植被高度产品',
          },
      ]
  },
  {
      value:'几何类产品',
      label:'几何类产品',
      children: [
          {
              value:'正射产品',
              label:'正射产品',
          },
          {
              value:'高程产品',
              label:'高程产品',
          }
      ]
  },
  {
      value:'大气类产品',
      label:'大气类产品',
      children: [
          {
              value:'气溶胶光学厚度产品',
              label:'气溶胶光学厚度产品',
          },
          {
              value:'大气水汽含量产品',
              label:'大气水汽含量产品',
          }
      ]
  },
  {
      value:'陆表类产品',
      label:'陆表类产品',
      children: [
          {
              value:'地表覆盖类型产品',
              label:'地表覆盖类型产品',
          },
          {
              value:'地表反射率产品',
              label:'地表反射率产品',
          },
          {
              value:'地表温度产品',
              label:'地表温度产品',
          },
          {
              value:'地表粗糙度',
              label:'地表粗糙度',
          },
          {
              value:'土壤盐碱度',
              label:'土壤盐碱度',
          },
          {
              value:'地表土壤水分产品',
              label:'地表土壤水分产品',
          },
          {
              value:'干涉测量形变产品',
              label:'干涉测量形变产品',
          }
      ]
  },
]

// 卫星种类
export const algSatelliteTypeOptions = [
  {
    value: "光学卫星",
    label: "光学卫星"
  },
  {
    value: "雷达卫星",
    label: "雷达卫星"
  },
  {
    value: "电磁卫星",
    label: "电磁卫星"
  },
  {
    value: "高光谱卫星",
    label: "高光谱卫星"
  },
  {
    value: "热红外卫星",
    label: "热红外卫星"
  }
]

// 卫星名称
export const algSatelliteNameOptions = {
  "光学卫星": [
    {
      value: "GF7",
      label: "GF7"
    },
    {
      value: "GF6",
      label: "GF6"
    },
    {
      value: "GF1B",
      label: "GF1B"
    },
    {
      value: "GF1C",
      label: "GF1C"
    },
    {
      value: "GF1D",
      label: "GF1D"
    },
    {
      value: "GF2",
      label: "GF2"
    },
    {
      value: "GF1",
      label: "GF1"
    },
    {
      value: "GF4",
      label: "GF4"
    },
    {
      value: "GF5",
      label: "GF5"
    },
    {
      value: "HJ2A",
      label: "HJ2A"
    },
    {
      value: "HJ2B",
      label: "HJ2B"
    },
    {
      value: "HJ1A",
      label: "HJ1A"
    },
    {
      value: "HJ1B",
      label: "HJ1B"
    },
    {
      value: "CBERS04A",
      label: "CBERS04A"
    },
    {
      value: "CBERS04",
      label: "CBERS04"
    },
    {
      value: "CBERS02B",
      label: "CBERS02B"
    },
    {
      value: "CBERS02",
      label: "CBERS02"
    },
    {
      value: "CBERS01",
      label: "CBERS01"
    },
    {
      value: "ZY1F",
      label: "ZY1F"
    },
    {
      value: "ZY303",
      label: "ZY303"
    },
    {
      value: "ZY1E",
      label: "ZY1E"
    },
    {
      value: "ZY302",
      label: "ZY302"
    },
    {
      value: "ZY3",
      label: "ZY3"
    },
    {
      value: "ZY02C",
      label: "ZY02C"
    },
  ],
  "雷达卫星": [
    {
      value: "GF3",
      label: "GF3"
    }
  ]
}
// 卫星载荷
export const algSatelliteSensorOptions = {
  "GF7": [
    {
      value: "DLC",
      label: "DLC"
    },
    {
      value: "BWD",
      label: "BWD"
    },
  ],
  "GF6": [
    {
      value: "WFV",
      label: "WFV"
    },
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "GF1B": [
    {
      value: "PMS",
      label: "PMS"
    }
  ],
  "GF1C": [
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "GF1D": [
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "GF2": [
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "GF1": [
    {
      value: "PMS",
      label: "PMS"
    },
    {
      value: "WFV",
      label: "WFV"
    },
  ],
  "GF4": [
    {
      value: "B1",
      label: "B1"
    },
    {
      value: "IRS",
      label: "IRS"
    },
    {
      value: "PMI",
      label: "PMI"
    },
    {
      value: "B2",
      label: "B2"
    },
    {
      value: "B3",
      label: "B3"
    },
    {
      value: "B4",
      label: "B4"
    },
    {
      value: "B5",
      label: "B5"
    },
    {
      value: "PI",
      label: "PI"
    },
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "GF5": [
    {
      value: "AHSI",
      label: "AHSI"
    },
    {
      value: "VIMS",
      label: "VIMS"
    },
  ],
  "HJ2A": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "HSI",
      label: "HSI"
    },
    {
      value: "IRS",
      label: "IRS"
    },
  ],
  "HJ2B": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "HSI",
      label: "HSI"
    },
    {
      value: "IRS",
      label: "IRS"
    },
  ],
  "HJ1A": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "HSI",
      label: "HSI"
    },
  ],
  "HJ1B": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "IRS",
      label: "IRS"
    },
  ],
  "CBERS04A": [
    {
      value: "WPM",
      label: "WPM"
    },
    {
      value: "MUX",
      label: "MUX"
    },
    {
      value: "WFI",
      label: "WFI"
    },
  ],
  "CBERS04": [
    {
      value: "MUX",
      label: "MUX"
    },
    {
      value: "P10",
      label: "P10"
    },
    {
      value: "P5M",
      label: "P5M"
    },
    {
      value: "WFI",
      label: "WFI"
    },
    {
      value: "IRS",
      label: "IRS"
    },
  ],
  "CBERS02B": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "HR",
      label: "HR"
    },
    {
      value: "WFI",
      label: "WFI"
    },
  ],
  "CBERS02": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "WFI",
      label: "WFI"
    },
    {
      value: "IRS",
      label: "IRS"
    },
  ],
  "CBERS01": [
    {
      value: "CCD",
      label: "CCD"
    },
    {
      value: "WFI",
      label: "WFI"
    },
    {
      value: "IRS",
      label: "IRS"
    },
  ],
  "ZY1F": [
    {
      value: "AHSI",
      label: "AHSI"
    },
    {
      value: "IRS",
      label: "IRS"
    },
    {
      value: "VNIC",
      label: "VNIC"
    },
  ],
  "ZY303": [
    {
      value: "TMS",
      label: "TMS"
    },
    {
      value: "DLC",
      label: "DLC"
    },
    {
      value: "MUX",
      label: "MUX"
    },
    {
      value: "NAD",
      label: "NAD"
    },
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "ZY1E": [
    {
      value: "AHSI",
      label: "AHSI"
    },
    {
      value: "VNIC",
      label: "VNIC"
    },
  ],
  "ZY302": [
    {
      value: "TMS",
      label: "TMS"
    },
    {
      value: "DLC",
      label: "DLC"
    },
    {
      value: "MUX",
      label: "MUX"
    },
    {
      value: "NAD",
      label: "NAD"
    },
    {
      value: "PMS",
      label: "PMS"
    },
    {
      value: "TLC",
      label: "TLC"
    },
  ],
  "ZY3": [
    {
      value: "MUX",
      label: "MUX"
    },
    {
      value: "TLC",
      label: "TLC"
    },
    {
      value: "NAD",
      label: "NAD"
    },
  ],
  "ZY02C": [
    {
      value: "HRC",
      label: "HRC"
    },
    {
      value: "PMS",
      label: "PMS"
    },
  ],
  "GF3": [
    {
      value: "SL",
      label: "SL"
    },
    {
      value: "UFS",
      label: "UFS"
    },
    {
      value: "FSI",
      label: "FSI"
    },
    {
      value: "FSII",
      label: "FSII"
    },
    {
      value: "SS",
      label: "SS"
    },
    {
      value: "NSC",
      label: "NSC"
    },
    {
      value: "WSC",
      label: "WSC"
    },
    {
      value: "QPSI",
      label: "QPSI"
    },
    {
      value: "QPSII",
      label: "QPSII"
    },
    {
      value: "WAV",
      label: "WAV"
    },
    {
      value: "GLO",
      label: "GLO"
    },
    {
      value: "EXT",
      label: "EXT"
    },
  ],
}
// 交互类型
export const algInteractionTypeOptions = [
  {
    value: "ElementAlg",
    label: "ElementAlg"
  },
  {
    value: "HMProcess",
    label: "HMProcess"
  },
]
// 传递模式
export const algDeliveryModeOptions = [
  {
    value: "File",
    label: "File"
  },
  {
    value: "Memory",
    label: "Memory"
  },
]